import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
// import { clone } from '@/service/util'

export async function getBeneficios (id) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/inss/beneficios`)
}

export async function getExtrato (id, beneficio) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/inss/extrato/${beneficio}`)
}

export async function getCalculoInicial (id, beneficio) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/inss/calculo`)
}

export async function getExtratoAtualizado (id, beneficio) {
  return sessaoFetch(`base`, `/pedido/${id}/inss/atualizado/${beneficio}`)
}

export async function getExtratoBase (id, beneficio, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/inss/base/${beneficio}${dados}`)
}

export async function getExtratoRecalculo (id, beneficio, dados) {
  return sessaoFetch(`base`, `/pedido/${id}/inss/recalculo/${beneficio}`, 'PUT', dados)
}

export async function getExtratoReabre (id, beneficio) {
  return sessaoFetch(`base`, `/pedido/${id}/inss/atualizado/${beneficio}`)
}

export async function editaItens (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/inss/itens`, 'PUT', dados)
}

export async function getItens (id) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/itens/inss`, 'GET')
}

export async function lancar (id, dados) {
  return sessaoFetchLoading(`base`, `/pedido/${id}/lancar`, 'PUT', dados)
}

export async function salvaContrato (dados) {
  return sessaoFetchLoading(`base`, `/entidade/contrato`, 'POST', dados)
}

export async function editContrato (dados) {
  return sessaoFetchLoading(`base`, `/entidade/contrato`, 'PUT', dados)
}

export async function excluiContrato (id) {
  return sessaoFetchLoading(`base`, `/entidade/contrato/${id}`, 'DELETE')
}

export async function salvarBaseCalculo (payload) {
  return sessaoFetchLoading(`base`, `/entidade/beneficio/${payload.id}/salario`, 'PUT', { base_calc: payload.base_calc })
}

export async function salvarBeneficio (payload) {
  let ret = await sessaoFetchLoading(`base`, `/entidade/beneficio`, 'POST', payload)
  return ret
}

export async function calculaImpostoRenda (payload) {
  return sessaoFetchLoading(`base`, `/entidade/beneficio/${payload.id}/calculaImpostoRenda`, 'PUT', payload)
}

export async function getExtratoTodosRecalculo (id) {
  return sessaoFetch(`base`, `/pedido/${id}/inss/recalculo`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/inss.js